import { render, staticRenderFns } from "./background-video.vue?vue&type=template&id=7f65b19d&scoped=true&"
import script from "./background-video.vue?vue&type=script&lang=js&"
export * from "./background-video.vue?vue&type=script&lang=js&"
import style0 from "./background-video.vue?vue&type=style&index=0&id=7f65b19d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f65b19d",
  null
  
)

export default component.exports